import './DeparturesReportCreateFooter.scss';

import { useDeparturesReportForm } from "../../../../hooks/useDeparturesReportCreateForm";

import { Button } from "../../../../common-components/Buttons/Buttons";

const DeparturesReportCreateFooter = () => {
    const { handleSend } = useDeparturesReportForm();

    return (
        <div className={"departures-report-create-footer"}>
            <Button title={"Добавить"} onClick={handleSend}/>
        </div>
    )
}

export default DeparturesReportCreateFooter;